export default "__VITE_ASSET__0789f6c1__"